<template>
  <div class="homeHeaderCon">
    <div class="homeHeaderP" :style="{ 'background-color': homeheaderbgcolor }">
      <div class="homeHeader">
        <div class="logo" @click="gofirstPage">
          <img
            :class="{ beijing2022: isshowregis, other: !isshowregis }"
            v-if="logosrc"
            :src="logosrc"
            alt="logo"
            style="cursor:pointer"
          />
        </div>
        <div class="otherCon" :style="{ 'justify-content': navpos }">
          <div class="nav">
            <ul class="nav-content">
              <!-- 此处为高能所改变了page_name -->
              <li
                v-for="(item, index) in modelsInfo_real"
                v-if="item.status == 1"
                :key="index"
                @click="changeModel(item, index)"
              >
                <router-link
                  :class="{
                    activeSty: index == activeChanelIndex,
                    noactiveSty: index != activeChanelIndex,
                    disable: item.page_name == '视频素材11222211'
                  }"
                  :to="item.path"
                  v-text="item.page_name"
                ></router-link>
              </li>
            </ul>
          </div>
        </div>

        <div style=" align-items: center;display: flex;">
          <div class="loginBtn" v-if="!userInfo">
            <div class="btnContent">
              <div
                style="margin-right:5px"
                class="iconfont icon-Shapecopy"
              ></div>
              <div class="loginbtn-item">
                <router-link class="login-left" to="/login">登录</router-link>
              </div>
              <div>/</div>
              <div class="loginbtn-item">
                <router-link class="login-right" to="/register"
                  >注册</router-link
                >
              </div>
            </div>
          </div>
          <div class="userPerson userInfo" v-else>
            <el-dropdown trigger="click" placement="top" v-if="userInfo">
              <div class="personLogo">
                <span>
                  {{ userInfo.user_name }}
                  <i class="el-icon-arrow-down"></i>
                </span>
                <a class="userHead" v-if="!isshowregis">
                  <img :src="userInfo.img_path" alt />
                </a>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span @click="toPersonal">个人中心</span>
                </el-dropdown-item>
                <el-dropdown-item v-show="picshow == true">
                  <span @click="toDam">图库管理</span>
                </el-dropdown-item>
                <el-dropdown-item v-if="isVCGPermission">
                  <span @click="toVCG">VCG+</span>
                </el-dropdown-item>
                <el-dropdown-item v-if="!ifChildSite">
                  <span @click="signOut">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "changanNav",
  data() {
    return {
      homeheaderbgcolor: "#3366CC",
      navpos: "center",
      logo: {
        id: "",
        list: [{ photo1: "" }]
      },
      modelsInfo_real: []
    };
  },
  mount() {},
  created() {},
  computed: {
    router_change() {
      //获取一下频道id
      // console.log("获取一下频道id", this.curModelInfo.id);
      return this.$route;
    },
    vcgpermissionss() {
      return localStorage.getItem("vcgtoken");
    },
    logosrc() {
      if (this.logo.list.length > 0) {
        this.setLogoSrc(this.logo.list[0].photo1);
        return this.logo.list[0].photo1;
      } else {
        this.setLogoSrc("");
        return "";
      }
    },
    ...mapGetters([
      "modelsInfo",
      "webModels",
      "curModelInfo",

      "activeChanelIndex",
      "login_success",
      "showSite"
    ])
  },
  watch: {
    login_success: {
      handler(val) {
        // console.log("登录成功了吗?", val);
        this.userInfo = sessionStorage.getItem("user")
          ? JSON.parse(sessionStorage.getItem("user"))
          : false;
        // user_type  类型1，注册用户，2内部用户，3供稿人，4签约用户，5内部供稿人，6编辑，7管理员
        if (this.userInfo) {
          let userroles = [3, 5, 6, 7];
          let user_type = this.userInfo.user_type;
          if (userroles.includes(user_type)) {
            this.showUploadAndQuery = true;
          }
          if (this.userInfo.user_type == 6 || this.userInfo.user_type == 7) {
            this.picshow = true;
          } else {
            this.picshow = false;
          }
        } else {
          localStorage.removeItem("vcgtoken");
        }
      },
      immediate: true
    },
    modelsInfo(val, oldval) {
      val.forEach(item => {
        item["path"] = this.getPathByTplId(item);
        this.modelsInfo_real.push(item);
      });
      if (!sessionStorage.getItem("first")) {
        sessionStorage.setItem("first", 0);
        sessionStorage.setItem("fitstPath", this.modelsInfo_real[0].path);
        this.setCurModelInfo(val[0]);
        let timer = setTimeout(() => {
          if (this.mustLogin && this.mustLoginEnd) {
            this.$router.push({ path: "/login" });
          } else {
            this.$router.push({ path: "/" + this.modelsInfo_real[0].path });
          }
          clearTimeout("timer");
        }, 1000);
      } else {
        let sindex = sessionStorage.getItem("first");
        this.setActiveChanelIndex(sindex);
        this.setCurModelInfo(val[sindex]);
      }
    }
  },
  methods: {
    ...mapActions([
      "setCurModelInfo",
      "setWebModels",
      "setActiveChanelIndex",
      "setLogoSrc",
      "setLoginSign"
    ]),

    gofirstPage() {
      this.setCurModelInfo(this.modelsInfo[0]);
      this.setActiveChanelIndex(0);
      sessionStorage.setItem("first", 0);
      this.$router.push({ path: "/" + this.modelsInfo_real[0].path });
    },
    signOut() {
      this.userInfo = false;
      signOut().then(res => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        localStorage.removeItem("vcgtoken");
        this.isVCGPermission = false;
        this.setLoginSign(false);

        this.$message.success("退出成功");

        window.location.href = "https://login.ihep.ac.cn/logout";
      });
    },

    getModuleInfo() {
      getModuleInfo({
        module_id: 40,
        web_id: this.webID
      }).then(res => {
        if (res.status_code == 1) {
          this.mustLogin = res.data.list[0].login_index == 1 ? true : false;
          sessionStorage.setItem("mustLogin", this.mustLogin);
        }
      });
      this.userInfo = sessionStorage.getItem("user")
        ? JSON.parse(sessionStorage.getItem("user"))
        : false;
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          var homeColor = this.webModels.module_data.find(item => {
            if (item.title == "首页底色") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            use_sort_num: 1,
            sort: "asc"
          };
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });
          data.module_id = homeColor.id;
          //
          getModuleInfo(
            { module_id: 5, use_sort_num: 1, sort: "asc" },
            null
          ).then(res => {
            if (res.status_code == 1) {
              this.homeColor = {
                id: homeColor.id,
                list: res.data.list
              };
              this.homeheaderbgcolor = pbmethod.colorRgb(
                this.homeColor.list[0].body
              );
            }
          });

          data = {
            module_id: 23,
            web_id: this.webID,
            use_sort_num: 1,
            sort: "asc"
          };
          getModuleInfo(data).then(res => {
            if (res.status_code == 1) {
              switch (res.data.list[0].nav) {
                case 1:
                  this.navpos = "flex-start";
                  break;
                case 2:
                  this.navpos = "center";
                  break;
                case 3:
                  this.navpos = "flex-end";
                  break;
              }
              this.isshowSidebar = eval(res.data.list[0].body4);
              this.sidebarQQ = res.data.list[0].body5;
              this.sidebarTel = res.data.list[0].body6;
              this.sidebarTime = res.data.list[0].body7;
            }
          });
        }
      }, 0);
    },
    changeModel(module, index) {
      // ;
      this.setCurModelInfo(module);
      // if (module.page_name == "视频素材") {
      //   this.$message({
      //     type: "warning",
      //     showClose: true,
      //     message: "建设中",
      //     duration: 1000
      //   });
      //   return;
      // }
      this.setActiveChanelIndex(index);
      sessionStorage.setItem("first", index);
      // if (module.tpl_id === 4) {
      //   this.$router.push({ path: "/special" });
      // } else {
      //   this.$router.push({ path: "/" });
      // }
    },
    getPathByTplId(item) {
      switch (item.tpl_id) {
        case 1:
          return "modeltwo";
        case 2:
          return "modelone";
        case 3:
          return "modelthree";
        case 4:
          return "special";
        case 10:
          return "loginbf";
        case 7:
          return "service";
        case 8:
          return "recommend";
        case 9:
          return "aboutus";
        case 6:
          return "modelad";
        case 11:
          return "allclassnew";
        case 13:
          return "modeltwonew";
        case 14:
          return "taskCollection";
        case 29:
          return "modelsix";
        case 30:
          return "categoryPageLy";
        case 31:
          return "adminOverview";
        case 32:
          return "categoryCustomPageLy";
        case 33:
          return "essence";
        case 34:
          return "modelvideo";
        case 35:
          // 视觉长安 未登录模板
          return "noLoginModel";
        case 36:
          // 视觉长安 已登录模板
          return "loginModel";
        case 37:
          // 视觉长安 创意拍摄
          return "creativePhoto";
        case 38:
          // 视觉长安 视频
          return "modelvideo2";
        case 39:
          // 创意视频 视频
          return "modelvideo3";
        case 40:
          // 微电影
          return "modelvideo4";
        case 41:
          return "territoryList";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.homeCon {
  display: flex;
  display: -webkit-flex;
  .activeSty {
    color: #fff;
    // font-weight: bold;
    font-size: 16px;
  }
  .noactiveSty {
    color: #fff;
    font-size: 13px;
  }
  .disable {
    color: rgba(121, 7, 7, 0.3);
  }
  .nav-content {
    li {
      margin: 0 20px;
    }
  }
  .homeHeaderCon {
    width: 100%;
    height: 80px;
    padding-left: 0px;
    padding-right: 0px;
    margin-right: auto;
    margin-left: auto;
  }
  .homeHeaderP {
    width: 100%;
    height: 80px;
    .homeHeader {
      margin: 0 auto;
      width: 1200px;
      height: 80px;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      z-index: 1000;
      .logo {
        height: 100%;
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;

        .beijing2022 {
          max-height: 60px;
          margin-left: 800px;
        }
        .other {
          max-width: 120px;
          max-height: 60px;
        }
      }
      .otherCon {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        width: calc(100% - 120px);
        .nav {
          height: 100%;
        }
      }
      .nav {
        margin-right: 20px;
        min-width: 200px;
        .nav-content {
          display: flex;
          height: 20px;
          font-size: 14px;
          font-family: PingFang-SC-Medium;
          line-height: 20px;
          height: 100%;
          // padding-top: 24px;
          justify-content: flex-start;

          li {
            color: rgba(44, 62, 76, 1);
            display: flex;
            display: -webkit-flex;
            align-items: center;
            a {
              // font-size: 14px;
            }
          }
        }
      }
      .search {
        width: 345px;
        height: 40px;
        margin-right: 40px;
        display: flex;
        .el-select {
          padding-right: 0;
          width: 150px;
        }
        .el-button {
          background-color: #f05941;
          color: #fff;
          padding: 0px;
          height: 40px;
          width: 40px;
          font-size: 20px;
        }
        .el-input-group {
          width: 250px;
        }
      }
      .loginBtn {
        width: 98px;
        height: 40px;

        border-radius: 3px;
        .btnContent {
          line-height: 20px;
          height: 20px;
          width: 85px;
          margin-top: 10px;
          margin-left: 8px;
          display: flex;
          justify-content: space-between;
          color: #fff;

          a {
            color: #fff;
            font-size: 14px;
          }
          a:hover {
            color: red;
          }
        }
      }
      .userInfo {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .personLogo {
          display: flex;
          display: -webkit-flex;
        }
        span {
          font-size: 16px;
          // line-height: 45px;
          cursor: pointer;
          vertical-align: middle;
          display: flex;
          display: -webkit-flex;
          align-items: center;
        }
        .userHead {
          margin-left: 10px;
          display: inline-block;
          width: 45px;
          height: 45px;
          vertical-align: middle;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }

      .homeHeaderTwo {
        width: 100%;
        height: 70px;
        position: fixed;
        display: flex;
        z-index: 1000;
        .logo {
          height: 100%;
          width: 120px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }
  }
  .homeHeaderP.transP {
    position: absolute !important;
    z-index: 900 !important;
    background: transparent !important;
    .nav-content {
      .noactiveSty {
        color: white;
      }
      .activeSty {
        color: white;
      }
    }
    .loginBtn {
      .loginbtn-item {
        a {
          color: white;
        }
      }
    }
  }
  .righttoolbal {
    width: 30px;
    background-color: #212121;
    z-index: 9999;
    color: white;
    .itemcon {
      position: fixed;
      top: 300px;
      width: 30px;
      .tel {
        background-color: red;
        position: relative;
        height: 100px;
        .telinfo {
          background-color: white;
          position: absolute;
          left: -150px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          color: #757575;
          padding-left: 20px;
          padding-top: 10px;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
      .collection {
        margin-top: 20px;
        position: relative;
        .collec {
          background-color: red;
        }
        .collectioninfo {
          background-color: red;
          position: absolute;
          left: -100px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          line-height: 24px;
          padding-left: 10px;
          text-align: center;
        }
      }
      .download {
        margin-top: 20px;
        position: relative;
        .jilu {
          background-color: red;
        }
        .downloadinfo {
          background-color: red;
          text-align: center;
          position: absolute;
          left: -100px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          line-height: 24px;
          padding-left: 10px;
        }
      }
      .txqq {
        margin-top: 20px;
        color: white;
        .txqqcon {
          position: relative;
          .qq {
            background-color: red;
          }
          .qqcom {
            background-color: red;
            color: white;
            position: absolute;
            left: -100px;
            top: 0px;
            bottom: 0px;
            right: 30px;
            line-height: 24px;
            padding-left: 10px;
          }
        }
      }
    }
  }
  .home {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/changanNav.vue